import React, { useState, useRef, useEffect } from "react";
import { Tree } from "primereact/tree";
import { ContextMenu } from "primereact/contextmenu";
import { Toast } from "primereact/toast";
import "./TreeStyle/flags.css";
import "./TreeStyle/style.css";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
// import "primereact/resources/themes/saga-blue/theme.css";
import { classNames } from "primereact/utils";

import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { SplitButton } from "primereact/splitbutton";

import { Button as PrimeButton } from "primereact/button";
import { Translation } from "react-i18next";
import Page from "../general/Page";
import { InputText } from "primereact/inputtext";
import i18next from "i18next";
import { Button, Card, Icon, Checkbox } from "antd";
import { Dropdown } from "primereact/dropdown";
import { CloseSquareOutlined } from "@ant-design/icons";
import covertJson2XmlAndUploadCallFlow from "./../../services/callFlow/generateICF";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Tooltip } from "primereact/tooltip";
import { Menu } from "primereact/menu";

import { ConfirmDialog } from "primereact/confirmdialog"; // For <ConfirmDialog /> component
import { confirmDialog } from "primereact/confirmdialog"; // For confirmDialog method
import { showSuccessToast, showErrorToast } from "../general/ToastHelper";
import { da, el, tr } from "date-fns/locale";
import AudioPlayer from "../streaming/AudioPlayer";

export default function TreePrime(props) {
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(false);

  const [choicesNameInvalid, setChoicesNameInvalid] = useState(false);
  const [flowNameInvalid, setFlowNameInvalid] = useState(false);
  const [flowNameInDialogInvalid, setFlowNameInDialogInvalid] = useState(false);
  const [addPlayVoiceNodeName, setAddPlayVoiceNodeName] = useState(false);
  const [addPlayVoicePromptInvalid, setAddPlayVoicePromptInvalid] =
    useState(false);

    const [addPlayVoiceNodeNameForEditStep, setAddPlayVoiceNodeNameForEditStep] = useState(false);
    const [editkeyPadChoiceStep, setEditkeyPadChoiceStep] = useState(false);


  const [visibleAddPlay, setVisibleAddPlay] = useState(false);
  const [visibleAddChoice, setVisibleAddChoice] = useState(false);
  const [visibleCallFlowName, setVisibleCallFlowName] = useState(
    props.treeData.length == 0 ? true : false
  );
  const [callFlowName, setCallFlowName] = useState(props.flowName);
  const [nodePlayName, setNodePalyName] = useState("");

  const [data, setData] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState({
    0: true,
    "0-0": true,
    "0_1": true,
    "0_1_1": true,
    "0_1_1_1": true,
    "0_1_1_2": true,
    "0_1_2": true,
    "0_1_2_1": true,
    "0_1_2_1_1": true,
  });
  const [selectedNodeKey, setSelectedNodeKey] = useState(null);
  const [selectedNodeType, setSelectedNodeType] = useState(null);

  const toast = useRef(null);
  const cm = useRef(null);
  const [position, setPosition] = useState("center");
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedGoTo, setSelectedGoTo] = useState(null);
  const [tooltipText, setTooltipText] = useState("");

  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [selectWaitingMsg, setWaitingMsg] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [choiceNodeName, setChoiceNodeName] = useState("");
  const [showChoiceNodeName, setShowChoiceNodeName] = useState(true);
  const [loading, setLoading] = useState(false);
  const [interrupt, setInterrupt] = useState(false);
  const [visibleModalEditPlayNode, setVisibleModalEditPlayNode] =
    useState(false);
  const [visibleModalEditChoiceNode, setVisibleModalEditChoiceNode] =
    useState(false);
  const [formData, setFormData] = useState({
    inputText: "",
    dropdown1: null,
    dropdown2: null,
    dropdown3: null,
    dropdown4: null,
    checkbox: false,
  });
  const [visibleModalEditKeypadchoices, setVisibleModalEditKeypadchoices] =
    useState(false);
  const [mount, setMount] = useState(false);
  const menuButton = useRef(null);
  useEffect(() => {
    setMount(true);
    setData(props.treeData);
  }, []);

  useEffect(() => {
    if (props.preventNavigate) {
      // if (props.editFlag) {
      //   confirm("top");
      // } else {
        if(trigger){
          confirm2("top");

        }else{
          props.navigate();
        }
      // }
    }
  }, [props.preventNavigate]);

  const goTo = [
    { label: i18next.t("Play Voice"), value: "play" },
    { label: i18next.t("Transfer To"), value: "transfer" },
  ];

  const prompts = props.prompts;
  // const agentGroups = props.agentGroups;

  const [agentGroups, setAgentGroups] =
  useState(props.agentGroups);

  const isValidInput = (value) => /^[0-9*#]$/.test(value);

  const footerCallFlowNameModal = (
    <div>
      <Button
        className="button-submit"
        type="primary"
        onClick={() => {
          setTrigger(true)
          if (callFlowName.trim() == "") {
            setFlowNameInDialogInvalid(true);
          } else {
            setVisibleCallFlowName(false);
          }
        }}
        size={"small"}
      >
        {i18next.t("Submit")}
      </Button>
    </div>
  );
  const modalCallFlowName = (
    <Dialog
      header={i18next.t("Call Flow Name")}
      visible={visibleCallFlowName}
      // style={{ width: "30vw" }}
      footer={footerCallFlowNameModal}
      draggable={true}
      resizable={true}
      closable={true}
      onHide={() => {
        props.back(true);
      }}
    >
      <div className="card flex  flex-column gap-2 justify-content-center">
        <InputText
          type="text"
          placeholder={i18next.t("Enter Call Flow Name")}
          value={callFlowName}
          onChange={(e) => {
            setFlowNameInDialogInvalid(false);
            setCallFlowName(e.target.value);
          }}
          className={classNames({
            "p-invalid": flowNameInDialogInvalid,
            "p-inputtext-sm": true,
            "md:w-14rem": true,
          })}
        />
            {flowNameInDialogInvalid && (
              <small
                className="p-error m-1 align-items-center" 
                // style={{
                //   marginRight: props.currLang == "ar" ? "90px" : "0px",
                //   marginLeft: props.currLang == "ar" ? "0px" : "92px",
                // }}
              >
                {i18next.t("Flow Name is required")}
              </small>
            )}
      </div>
    </Dialog>
  );

  const footerAddPlayModal = (
    <div>
      <Button
        className="button-submit"
        type="primary"
        onClick={() => {
          setTrigger(true)

          if (selectedPrompt == null) {
            setAddPlayVoicePromptInvalid(true);
            return;
          }
          if (nodePlayName.trim() == "") {
            setAddPlayVoiceNodeName(true);
            return;
          }
          let nodeName = nodePlayName;
          if (data.length == 0) {
            addNode(
              selectedNodeKey,
              nodeName,
              selectedPrompt,
              "play",
              "pi pi-play",
              interrupt
            );
          } else {
            addNode(
              selectedNodeKey,
              nodeName,
              selectedPrompt,
              "play",
              "pi pi-play",
              interrupt
            );
          }
          setNodePalyName("");
          setInterrupt(false);
          setSelectedPrompt(null);
          setVisibleAddPlay(false);
        }}
        size={"small"}
        // disabled={selectedPrompt == null}
      >
        {i18next.t("Submit")}
      </Button>
    </div>
  );
  const footerEditPlayNodeModal = (
    <div>
      <Button
        className="button-submit"
        type="primary"
        onClick={() => {
          setTrigger(true)

          if(nodePlayName.trim()==""){
            setAddPlayVoiceNodeNameForEditStep(true);
            return;
          }
          let nodeName = nodePlayName;
          let newTree = updateNode(
            data,
            selectedNodeKey,
            nodeName,
            selectedPrompt,
            interrupt,
            "play",
            "pi pi-play"
          );
          setData(newTree);

          setNodePalyName("");
          setInterrupt(false);
          setSelectedPrompt(null);
          setVisibleModalEditPlayNode(false);
        }}
        size={"small"}
        // disabled={selectedPrompt == null || nodePlayName.trim() == ""}
      >
        {i18next.t("Submit")}
      </Button>
    </div>
  );
  const footerEditChoiceNodeModal = (
    <div>
      <Button
        className="button-submit"
        type="primary"
        onClick={() => {
          setTrigger(true)

          if(choiceNodeName.trim()==""){
            return;
          }
          let nodeName = choiceNodeName;
          let newTree = updateNode(
            data,
            selectedNodeKey,
            nodeName,
            null,
            null,
            "choice",
            ""
          );
          setData(newTree);

          setChoiceNodeName("");
          setVisibleModalEditChoiceNode(false);

        }}
        size={"small"}
        // disabled={choiceNodeName.trim() == ""}
      >
        {i18next.t("Submit")}
      </Button>
    </div>
  );

  const footerModalEditKeypadchoices = (
    <div>
      <Button
        className="button-submit"
        type="primary"
        onClick={() => {
          setTrigger(true)

          if (!isValidInput(formData.inputText)) {
            setEditkeyPadChoiceStep(true);
            // toast.current.show({
            //   severity: "error",
            //   summary: i18next.t("warn"),
            //   detail: i18next.t("Please Enter Valid Choice"),
            // });
            return;
          }
          try{
          const selectedNode = findNode(data, selectedNodeKey);
          const parentOfSelectedNode=findNode(data,selectedNode.parentKey)
          parentOfSelectedNode.children.forEach((element)=>{
            if(formData.inputText == element.nodeData.charInput && element.key !=selectedNodeKey){
              throw new Error("Choice Number should not be duplicated");
            }

          })
          if(formData.dropdown1 == "play" && formData.dropdown4==null){
            throw new Error("Please Select Prompt");

          }
          if(formData.dropdown1 == "transfer" &&formData.dropdown2==null){
            throw new Error("Please Select Group");

          }
          if(formData.dropdown1 == "transfer" && formData.dropdown3==null){
            throw new Error("Please Select Waiting Message");

          }
          
          let newLabel;
          if (formData.dropdown1 == "play") {
            newLabel =
              formData.inputText +
              " " +
              i18next.t(formData.dropdown1) +
              " " +
              formData.dropdown4.name;
          } else {
            newLabel =
              formData.inputText +
              " " +
              i18next.t(formData.dropdown1) +
              " " +
              formData.dropdown2.groupName;
          }
          let newNodeData = {
            charInput: formData.inputText,
            dropdown1: formData.dropdown1,
            agentGrp:
              formData.dropdown1 == "transfer" ? formData.dropdown2 : null,
            waitingMsg:
              formData.dropdown1 == "transfer" ? formData.dropdown3 : null,
            voiceMsg: formData.dropdown1 == "play" ? formData.dropdown4 : null,
            isChecked: formData.dropdown1 == "play" ? formData.checkbox : null,
          };
          let newNodes = updateNode(
            data,
            selectedNodeKey,
            newLabel,
            newNodeData,
            false,
            formData.dropdown1 == "play" ? "playChoice" : "group",
            formData.dropdown1 == "play" ? "pi pi-play" : "pi pi-users"
          );
          setData(newNodes);
          setFormData({
            inputText: "",
            dropdown1: null,
            dropdown2: null,
            dropdown3: null,
            dropdown4: null,
            checkbox: false,
          });
          setVisibleModalEditKeypadchoices(false);
        }catch(err){
          toast.current.show({
            severity: "error",
            summary: i18next.t("warn"),
            detail: i18next.t(err.message),
          });
          return;
        }
        }}
        size={"small"}
        // disabled={formData.inputText.trim() == ""}
      >
        {i18next.t("Submit")}
      </Button>
    </div>
  );
  const modalAddPlay = (
    <Dialog
      header={i18next.t("Play Voice")}
      visible={visibleAddPlay}
      onHide={() => {
        setSelectedNodeKey(null);
        setVisibleAddPlay(false);
        setAddPlayVoiceNodeName(false);
        setAddPlayVoicePromptInvalid(false);
      }}
      footer={footerAddPlayModal}
      draggable={true}
      resizable={true}
    >
      <div className="card  justify-content-center">
        <Dropdown
          value={selectedPrompt}
          onChange={(e) => {
            setSelectedPrompt(e.value);
            setAddPlayVoicePromptInvalid(false);
          }}
          options={prompts}
          optionLabel="name"
          placeholder={i18next.t("Please Select Prompt")}
          className={classNames({
            "p-invalid": addPlayVoicePromptInvalid,
            flex: true,
            "align-items-center": true,
            "justify-content-center": true,
            "w-14rem": true,
            "m-1": true,
          })}
        />
        {addPlayVoicePromptInvalid &&<small className="p-error m-2 align-items-center">{i18next.t("Please Select Prompt")}</small>}
      </div>
      <div className="card  justify-content-center">
        <InputText
          type="text"
          placeholder={i18next.t("Enter Step Name")}
          className={classNames({
            "p-invalid": addPlayVoiceNodeName,
            flex: true,
            "align-items-center": true,
            "justify-content-center": true,
            "w-14rem": true,
            "m-1": true,
          })}
          value={nodePlayName}
          onChange={(e) => {
            setAddPlayVoiceNodeName(false);
            setNodePalyName(e.target.value);
          }}
        />
                {addPlayVoiceNodeName &&<small className="p-error m-2 align-items-center">{i18next.t("Step Name is required")}</small>}

      </div>
      <div className="card  justify-content-center m-1">
        <label>{i18next.t("Interrupt on DTMF") + ":"}</label>
        <Checkbox
          className="m-1"
          checked={interrupt}
          onChange={(e) => setInterrupt(e.target.checked)}
        />
      </div>
    </Dialog>
  );

  const modalEditPlayNode = (
    <Dialog
      header={i18next.t("Edit Call Flow Step")}
      visible={visibleModalEditPlayNode}
      onHide={() => {
        setNodePalyName("");
        setInterrupt(false);
        setSelectedPrompt(null);

        setSelectedNodeKey(null);
        setVisibleModalEditPlayNode(false);
      }}
      footer={footerEditPlayNodeModal}
      draggable={true}
      resizable={true}
    >
      <div className="card  justify-content-center">
        <Dropdown
          value={selectedPrompt}
          onChange={(e) => {
            setSelectedPrompt(e.value);
          }}
          options={prompts}
          optionLabel="name"
          placeholder={i18next.t("Please Select Prompt")}


          className={classNames({
            // "p-invalid": addPlayVoiceNodeNameForEditStep,
            flex: true,
            "align-items-center": true,
            "justify-content-center": true,
            "w-14rem": true,
            "m-1": true,
          })}
        />
      </div>
      <div className="card  justify-content-center">
        <InputText
          type="text"
          placeholder={i18next.t("Enter Step Name")}
          // className="flex align-items-center justify-content-center w-14rem m-1"
          className={classNames({
            "p-invalid": addPlayVoiceNodeNameForEditStep,
            flex: true,
            "align-items-center": true,
            "justify-content-center": true,
            "w-14rem": true,
            "m-1": true,
          })}
          value={nodePlayName}
          onChange={(e) => {
            setAddPlayVoiceNodeNameForEditStep(false);
            setNodePalyName(e.target.value)
          }}
        />
            {addPlayVoiceNodeNameForEditStep &&<small className="p-error m-2 align-items-center"> {i18next.t("Step Name is required")} </small>}

      </div>
      <div className="card  justify-content-center m-1">
        <label>{i18next.t("Interrupt on DTMF") + ":"}</label>
        <Checkbox
          className="m-1"
          checked={interrupt}
          onChange={(e) => setInterrupt(e.target.checked)}
        />
      </div>
    </Dialog>
  );

  const modalEditChoiceNode = (
    <Dialog
      header={i18next.t("Edit Call Flow Step")}
      visible={visibleModalEditChoiceNode}
      onHide={() => {
        setChoiceNodeName("");
        setSelectedNodeKey(null);
        setVisibleModalEditChoiceNode(false);
      }}
      footer={footerEditChoiceNodeModal}
      draggable={true}
      resizable={true}
    >
      <div className="card  justify-content-center">
        <InputText
          type="text"
          placeholder={i18next.t("Enter Step Name")}
          className="flex align-items-center justify-content-center w-14rem m-1"
          value={choiceNodeName}
          onChange={(e) => setChoiceNodeName(e.target.value)}
        />
                    {choiceNodeName.trim()=="" &&<small className="p-error m-2 align-items-center"> {i18next.t("Step Name is required")} </small>}

      </div>
    </Dialog>
  );
  const handleInputChangeOfEditKeypad = (e) => {
    setEditkeyPadChoiceStep(false)
    const { name, value, checked, options, type } = e.target;
    const inputValue = type === "checkbox" ? checked : value;
    setFormData({
      ...formData,
      [name]: inputValue,
    });
  };

  const modalEditKeypadchoices = (
    <Dialog
      header={i18next.t("Edit Call Flow Step")}
      visible={visibleModalEditKeypadchoices}
      onHide={() => {
        setFormData({
          inputText: "",
          dropdown1: null,
          dropdown2: null,
          dropdown3: null,
          dropdown4: null,
          checkbox: false,
        });
        setSelectedNodeKey(null);
        setVisibleModalEditKeypadchoices(false);
      }}
      footer={footerModalEditKeypadchoices}
      draggable={true}
      resizable={true}
      style={{ width: "25%" }}
    >
      <form>
        <div className="p-field m-2">
          <InputText
            id="inputText"
            name="inputText"
            value={formData.inputText}
            onChange={handleInputChangeOfEditKeypad}
            placeholder={i18next.t("Choice")}
            // className="w-full"
            className={classNames({
              "p-invalid": editkeyPadChoiceStep,
             "w-full":true
            })}
            maxLength={1}
            tooltip={i18next.t("Enter numbers from 0-9 or * or #")}
            tooltipOptions={{ position: "bottom" }}
          />
                      {editkeyPadChoiceStep &&<small className="p-error m-2 align-items-center"> {i18next.t("Choice is required")} </small>}

        </div>

        {/* Dropdowns */}
        <div className="p-field m-2">
          <Dropdown
            id="dropdown1"
            value={formData.dropdown1}
            options={goTo}
            onChange={(e) =>
              handleInputChangeOfEditKeypad({
                target: { name: "dropdown1", value: e.value },
              })
            }
            placeholder={i18next.t("Please select an action")}
            className="w-full"
          />
        </div>
        {formData.dropdown1 == "transfer" ? (
          <>
            <div className="p-field m-2">
              <Dropdown
                id="dropdown2"
                optionLabel="groupName"
                value={formData.dropdown2}
                options={agentGroups}
                onChange={(e) =>
                  handleInputChangeOfEditKeypad({
                    target: { name: "dropdown2", value: e.value },
                  })
                }
                placeholder="Please Select Group"
                className="w-full"
              />
            </div>
            <div className="p-field m-2">
              <Dropdown
                id="dropdown3"
                optionLabel="name"
                value={formData.dropdown3}
                options={prompts}
                onChange={(e) =>
                  handleInputChangeOfEditKeypad({
                    target: { name: "dropdown3", value: e.value },
                  })
                }
                placeholder="Select Waiting"
                className="w-full"
              />
            </div>
          </>
        ) : (
          <>
            <div className="p-field m-2">
              <Dropdown
                id="dropdown4"
                optionLabel="name"
                value={formData.dropdown4}
                options={prompts}
                onChange={(e) =>
                  handleInputChangeOfEditKeypad({
                    target: { name: "dropdown4", value: e.value },
                  })
                }
                placeholder={i18next.t("Please Select Prompt")}
                className="w-full"
              />
            </div>
            <div className="p-field-checkbox m-2">
              <label htmlFor="checkbox">Interrupt on DTMF:</label>

              <Checkbox
                inputId="checkbox"
                name="checkbox"
                checked={formData.checkbox}
                onChange={handleInputChangeOfEditKeypad}
              />
            </div>
          </>
        )}
      </form>
    </Dialog>
  );

  const accept = () => {
    const updatedTreeData = removeNode(data, selectedNodeKey);
    setData(updatedTreeData);
  };

  const reject = () => {};

  const removeNode = (data, keyToRemove) => {
    if (keyToRemove == "0") {
      setSelectedNodeKey(null);
      return [];
    }
    return data.filter((node) => {
      if (node.key === keyToRemove) {
        return false;
      } else if (node.children) {
        node.children = removeNode(node.children, keyToRemove);
      }
      return true;
    });
  };
  const updateNode = (nodes, key, newLabel, data, interrupt, type, icon) => {
    return nodes.map((node) => {
      if (node.key === key) {
        return {
          ...node,
          label: newLabel,
          type: type,
          icon: icon,
          nodeData: data,
          interrupt: interrupt,
          typeName: type,
          children: type == "group" ? [] : node.children,
        };
      }

      if (node.children && node.children.length > 0) {
        node.children = updateNode(
          node.children,
          key,
          newLabel,
          data,
          interrupt,
          type,
          icon
        );
      }
      return node;
    });
  };

  const menu = () => {
    let node = findNode(data, selectedNodeKey);
    let menuItems = null;
    if (node != null && node.typeName == "group") {

      menuItems = [
        {
          label: i18next.t("Edit"),
          icon: "pi pi-user-edit",
          command: () => {
            setTrigger(true)

            let filteredAgentGrp = agentGroups.filter((elem)=>{
              return elem.groupId == node.nodeData.agentGrp.groupId

            });
            setFormData({
              ...formData,
              inputText: node.nodeData.charInput,
              dropdown1: goTo[1].value,
              dropdown2: filteredAgentGrp[0],
              dropdown3: node.nodeData.waitingMsg,
              dropdown4: null,
              checkbox: false,
            });
            setVisibleModalEditKeypadchoices(true);
          },
        },
        {
          label: i18next.t("Delete"),
          icon: "pi pi-delete-left",
          command: () => {
            setTrigger(true)

            let node = findNode(data, selectedNodeKey);
            confirmPopup({
              target: undefined,
              message:
                i18next.t("Do you want to delete ") +
                '"' +
                node.label +
                '"' +
                i18next.t("?"),
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept,
              reject,
              acceptLabel: i18next.t("Yes"),
              rejectLabel: i18next.t("No"),
            });
            // const updatedTreeData = removeNode(data, selectedNodeKey);
            // setData(updatedTreeData);
          },
        },
      ];
    } else if (node != null && node.typeName == "choice") {
      menuItems = [
        {
          label: i18next.t("Edit"),
          icon: "pi pi-user-edit",
          command: () => {
            setTrigger(true)
            setChoiceNodeName(node.label);
            setVisibleModalEditChoiceNode(true);
          },
        },
        {
          label: i18next.t("Delete"),
          icon: "pi pi-delete-left",
          command: () => {
            setTrigger(true)

            let node = findNode(data, selectedNodeKey);
            confirmPopup({
              target: undefined,
              message:
                i18next.t("Do you want to delete ") +
                '"' +
                node.label +
                '"' +
                i18next.t("?"),
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept,
              reject,
              acceptLabel: i18next.t("Yes"),
              rejectLabel: i18next.t("No"),
            });
          },
        },
        {
          label: i18next.t("Add Choices"),
          icon: "pi pi-fw pi-plus",
          command: () => {
            setTrigger(true)

            setFormGroups([
              {
                id: 1,
                charInput: "",
                dropdown1: "play",
                agentGrp: null,
                waitingMsg: null,
                voiceMsg: null,

                isChecked: false,
              },
            ]);
            if (node.typeName == "choice") {
              setChoiceNodeName(node.label);
              setShowChoiceNodeName(false);
            } else {
              setChoiceNodeName("");
              setShowChoiceNodeName(true);
            }
            setFormValues({});

            setVisibleAddChoice(true);
          },
        },
      ];
    } else {
      menuItems = [
        {
          label: i18next.t("Edit"),
          icon: "pi pi-user-edit",
          command: () => {
            setTrigger(true)
            if (node != null && node.typeName == "play") {
              setSelectedPrompt(node.nodeData);
              setNodePalyName(node.label);
              setInterrupt(node.interrupt);
              setVisibleModalEditPlayNode(true);
            }
            if (node != null && node.typeName == "playChoice") {

              setFormData({
                ...formData,
                inputText: node.nodeData.charInput,
                dropdown1: goTo[0].value,
                dropdown4: node.nodeData.voiceMsg,
                checkbox: node.nodeData.isChecked,
                dropdown2: null,
                dropdown3: null,
              });
              setVisibleModalEditKeypadchoices(true);
            }
          },
        },
        {
          label: i18next.t("Delete"),
          icon: "pi pi-delete-left",
          command: () => {
            setTrigger(true)
            let node = findNode(data, selectedNodeKey);
            confirmPopup({
              target: undefined,
              message:
                i18next.t("Do you want to delete ") +
                '"' +
                node.label +
                '"' +
                i18next.t("?"),
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept,
              reject,
              acceptLabel: i18next.t("Yes"),
              rejectLabel: i18next.t("No"),
            });
          },
        },
        {
          label:
            selectedNodeKey == "0-0"
              ? i18next.t("Add Sub Call Flow")
              : i18next.t("Add Sub Call Flow"),
          icon: "pi pi-plus",
          items: [
            {
              label: i18next.t("Play Voice"),
              icon: "pi pi-fw pi-play",
              command: () => {
                setTrigger(true)

                setVisibleAddPlay(true);
              },
            },
            {
              label: i18next.t("Add Choices"),
              icon: "pi pi-fw pi-plus",
              command: () => {
                setTrigger(true)

                setFormGroups([
                  {
                    id: 1,
                    charInput: "",
                    dropdown1: "play",
                    agentGrp: null,
                    waitingMsg: null,
                    voiceMsg: null,

                    isChecked: false,
                  },
                ]);
                if (node.typeName == "choice") {
                  setShowChoiceNodeName(false);
                } else {
                  setShowChoiceNodeName(true);
                }
                setFormValues({});
                setChoiceNodeName("");
                setVisibleAddChoice(true);
              },
            },
          ],
          disabled:
            node != null &&
            (node.typeName == "play" || node.typeName == "playChoice") &&
            node.children.length > 0
              ? true
              : false,
        },
      ];
    }

    return menuItems;
  };

  const items = [
    {
      label: i18next.t("Play Voice"),
      icon: "pi pi-play",

      command: () => {
        setTrigger(true)

        setVisibleAddPlay(true);
      },
    },
    {
      label: i18next.t("Add Choices"),
      icon: "pi pi-plus",
      disabled: true,
    },
  ];

  const [formGroups, setFormGroups] = useState([
    {
      id: 1,
      charInput: "",
      dropdown1: "play",
      agentGrp: null,
      waitingMsg: null,
      voiceMsg: null,

      isChecked: false,
    },
  ]);

  const addFormGroup = () => {
    const newId = formGroups.length + 1;
    setFormGroups([
      ...formGroups,
      {
        id: newId,
        charInput: "",
        dropdown1: "play",
        agentGrp: null,
        waitingMsg: null,
        voiceMsg: null,
        isChecked: false,
      },
    ]);
  };

  const removeFormGroup = (index) => {
    const updatedFormGroups = [...formGroups];
    updatedFormGroups.splice(index, 1);
    setFormGroups(updatedFormGroups);
  };

  const handleInputChange = (index, key, value) => {
    const updatedFormGroups = [...formGroups];
    updatedFormGroups[index][key] = value;
    setFormGroups(updatedFormGroups);
  };

  const handleSave = () => {
    let selectedNode = findNode(data, selectedNodeKey);
    let key = null;
    let keyForAddChoiceNode = null;
    if (
      selectedNode.typeName == "play" ||
      selectedNode.typeName == "playChoice"
    ) {
      key = addNode(selectedNodeKey, choiceNodeName, null, "choice", "", null);
      keyForAddChoiceNode = key;
    } else {
      key = selectedNodeKey;
    }
  let charInputs=[];
  if(selectedNode.type=="choice" || selectedNode.type =="3"){
    
    if(selectedNode.children.length >0){
      selectedNode.children.forEach((element)=>{
        charInputs.push(element.nodeData.charInput);
      })
    }
  }

    
    const allFormValues = {};
    try {
      formGroups.forEach((group) => {

        if(charInputs.includes(group.charInput)){
          throw new Error("Choice Number should not be duplicated");
        }
        charInputs.push(group.charInput);
        allFormValues[group.id] = {
          charInput: group.charInput,
          dropdown1: group.dropdown1,
          agentGrp: group.agentGrp,
          waitingMsg: group.waitingMsg,
          voiceMsg: group.voiceMsg,
          isChecked: group.isChecked,
        };
        let type = group.dropdown1 == "play" ? "playChoice" : "group";
        let icon = group.dropdown1 == "play" ? "pi pi-play" : "pi pi-users";
        let label = "";
        if (group.charInput.trim() == "" || !isValidInput(group.charInput)) {
          throw new Error("Please Enter Valid Choice");
        }
        if (group.dropdown1 == "play") {
          if (group.voiceMsg == null) {
            throw new Error("Please Select Prompt");
          }
          label =
            group.charInput + " " + group.dropdown1 + " " + group.voiceMsg.name;
        } else {
          if (group.agentGrp == null) {
            throw new Error("Please Select Group");
          }
          if (group.waitingMsg == null) {
            throw new Error("Please Select Waiting Message");
          }

          label =
            group.charInput +
            " " +
            group.dropdown1 +
            " " +
            group.agentGrp.groupName;
        }
        addNode(key, label, group, type, icon, group.isChecked);
      });
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: i18next.t("warn"),
        detail: i18next.t(err.message),
      });
      const updatedTreeData = removeNode(data, keyForAddChoiceNode);
      setData(updatedTreeData);
      return;
    }

    setFormValues(allFormValues);
    setVisibleAddChoice(false);
  };

  const startContent = (
    <>
      <React.Fragment>
        {data.length ? (
          <>
            <label className="m-2">{i18next.t("Flow Name:")}</label>
            <InputText
              type="text"
              placeholder={i18next.t("Enter Call Flow Name")}
              value={callFlowName}
              onChange={(e) => {
                setFlowNameInvalid(false);
                setCallFlowName(e.target.value);
              }}
              className={classNames({
                "p-invalid": flowNameInvalid,
                "p-inputtext-sm": true,
                "md:w-14rem": true,
                "m-3": true,
              })}
              disabled={props.editFlag}
            />
            {flowNameInvalid && (
              <small
                className="p-error"
                // style={{
                //   marginRight: props.currLang == "ar" ? "90px" : "0px",
                //   marginLeft: props.currLang == "ar" ? "0px" : "92px",
                // }}
              >
                {i18next.t("Flow Name is required")}
              </small>
            )}
          </>
        ) : (
          <>
            {"     "}
            {!visibleCallFlowName && (
              <>
                <label>{i18next.t("Flow Name:")}</label>
                <InputText
                  type="text"
                  placeholder={i18next.t("Enter Call Flow Name")}
                  value={callFlowName}
                  onChange={(e) => setCallFlowName(e.target.value)}
                  className={classNames({
                    "p-invalid": flowNameInvalid,
                    "p-inputtext-sm": true,
                    "md:w-14rem": true,
                    "m-3": true,
                  })}
                  disabled={props.editFlag}
                />{" "}
                <Menu
                  model={items}
                  popup
                  ref={menuButton}
                  id="popup_menu_left"
                />
                {/* <SplitButton
                  label="Start"
                  icon="pi pi-plus"
                  model={items}
                  className="p-button-danger"
                  style={{ height: "36px" }}
                ></SplitButton> */}
                <PrimeButton
                  label={i18next.t("Start")}
                  icon="pi pi-plus"
                  className="p-button-danger"
                  onClick={(event) => menuButton.current.toggle(event)}
                  aria-controls="popup_menu_left"
                  aria-haspopup
                />
                {flowNameInvalid && (
                  <small
                    className="p-error"
                    style={{
                      marginRight: props.currLang == "ar" ? "90px" : "0px",
                      marginLeft: props.currLang == "ar" ? "0px" : "92px",
                    }}
                  >
                    {i18next.t("Flow Name is required")}
                  </small>
                )}
              </>
            )}
          </>
        )}
      </React.Fragment>
    </>
  );
  const endContent = (
    <React.Fragment>
      <PrimeButton className="p-button-danger" onClick={() => {
      window.open("https://eur05.safelinks.protection.outlook.com/?url=https%3A%2F%2Fvhub.vodafone.com.eg%2F%2Fmedias%2F010-Hotline-Guide-V2.pdf%3Fcontext%3DbWFzdGVyfHJvb3R8MjQ3MDMxNnxhcHBsaWNhdGlvbi9wZGZ8aGUxL2hlNi85MjYyNDY3NDQ4ODYyLnBkZnxjZmUwOTdiZjk4YWQ4ZjU3MTFiOTFiMWNiNTI4OWI1OWIyZDRlNzM3YWFmNzVhMjEzMjMxYTIxNmNhNGZlN2U3&data=05%7C02%7Cnouran.mohamed3%40vodafone.com.eg%7C17672ba7d77b43a1cd6b08dd5caa8104%7C28d54ec722214717acb07f8c37359048%7C0%7C0%7C638768609580405867%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=95%2BgBJX7zXMXtPW5%2BBTE1jTpqow7%2Bb9nDxfyGnLJx1E%3D&reserved=0","_blank");
    }}
>
        {i18next.t("Help?")}
      </PrimeButton>
    </React.Fragment>
  );

  const modalAddChoices = (
    <Dialog
      visible={visibleAddChoice}
      onHide={() => {
        setChoicesNameInvalid(false);

        setVisibleAddChoice(false);
      }}
      header={i18next.t("Add Choices")}
    >
      {showChoiceNodeName && (
        <>
          <div className="input-container">
            <label>{i18next.t("Choices Name:")}</label>
            <InputText
              value={choiceNodeName}
              onChange={(e) => {
                setChoicesNameInvalid(false);
                setChoiceNodeName(e.target.value);
              }}
              placeholder={i18next.t("Enter Name for choices")}
              className={classNames({
                "p-invalid": choicesNameInvalid,
                "p-inputtext-sm": true,
              })}
            />
          </div>
          {choicesNameInvalid && (
            <small
              className="p-error"
              style={{
                marginRight: props.currLang == "ar" ? "90px" : "0px",
                marginLeft: props.currLang == "ar" ? "0px" : "92px",
              }}
            >
              {i18next.t("Choices Name is required")}
            </small>
          )}
          <br />
        </>
      )}
      <Button onClick={addFormGroup}>
        <Icon type="plus" />
      </Button>
      {formGroups.map((group, index) => (
        <div key={group.id} className="form-groups-container">
          <label className="m-2">{i18next.t("Choice Number") + ":"}</label>
          <div className="input-container m-1">
            <InputText
              value={group.charInput}
              onChange={(e) =>
                handleInputChange(index, "charInput", e.target.value)
              }
              maxLength={1}
              placeholder={i18next.t("Please Enter Choice Number")}
              className="p-inputtext-sm"
              required={true}
              tooltip={
                group.charInput == ""
                  ? i18next.t("Enter numbers from 0-9 or * or #")
                  : ""
              }
              tooltipOptions={{ position: "right" }}
            />
          </div>
          <div className="dropdown-container m-1">
            <label>{i18next.t("Pick Action") + ":"}</label>
            <Dropdown
              value={group.dropdown1}
              options={goTo}
              onChange={(e) => handleInputChange(index, "dropdown1", e.value)}
              placeholder={i18next.t("Select an action")}
            />
          </div>
          {group.dropdown1 == "transfer" && (
            <>
              <div className="dropdown-container m-1">
                <label>{i18next.t("Group Name:")}</label>
                <Dropdown
                  value={group.agentGrp}
                  options={agentGroups}
                  optionLabel="groupName"
                  onChange={(e) =>
                    handleInputChange(index, "agentGrp", e.value)
                  }
                  placeholder={i18next.t("Select a group")}
                />
              </div>
              <div className="dropdown-container m-1">
                <label>{i18next.t("Waiting Message") + ":"}</label>
                <Dropdown
                  value={group.waitingMsg}
                  onChange={(e) =>
                    handleInputChange(index, "waitingMsg", e.value)
                  }
                  options={prompts}
                  optionLabel="name"
                  placeholder={i18next.t("Select Message")}
                />
              </div>
            </>
          )}
          {group.dropdown1 == "play" && (
            <>
              <div className="dropdown-container m-1">
                <label>{i18next.t("Voice Message") + ":"}</label>

                <Dropdown
                  value={group.voiceMsg}
                  onChange={(e) =>
                    handleInputChange(index, "voiceMsg", e.value)
                  }
                  options={prompts}
                  optionLabel="name"
                  placeholder={i18next.t("Please Select Prompt")}
                />
              </div>
              <div className="checkbox-container m-1">
                <label>{i18next.t("Interrupt on DTMF")}</label>
                <Checkbox
                  className="m-1"
                  checked={group.isChecked}
                  onChange={(e) =>
                    handleInputChange(index, "isChecked", e.target.checked)
                  }
                />
              </div>
            </>
          )}

          <CloseSquareOutlined
            onClick={() => {
              removeFormGroup(index);
            }}
          />
        </div>
      ))}

      <Button
        className="button-submit"
        type="primary"
        onClick={() => {
          setTrigger(true)
          if (choiceNodeName.trim() == "") {
            setChoicesNameInvalid(true);
          } else {
            setChoicesNameInvalid(false);

            handleSave();
          }
        }}
        disabled={formGroups.length == 0}
        size={"small"}
      >
        {i18next.t("Save")}
      </Button>
    </Dialog>
  );

  const treeNodes = (nodes) => {
    return nodes.map((node) => ({
      key: node.key,
      icon:
        node.type == "1" || node.type == "play" || node.type == "playChoice"
          ? ""
          : node.icon,
      label:
        node.type == "1" || node.type == "play" || node.type == "playChoice" ? (
          <AudioPlayer
            record={node.nodeData}
            type="prompt"
            label={node.label}
          />
        ) : (
          node.label
        ),
      nodeData: node.nodeData,
      type: node.type,
      children: node.children.length > 0 ? treeNodes(node.children) : null,
    }));
  };
  const nodeTemplate = (node) => {
    return (
      <div>
        <span
          onMouseEnter={(e) =>
            setTooltipText(i18next.t("Right click to add, edit or delete step"))
          }
          onMouseLeave={() => setTooltipText("")}
          className="p-overlay-badge"
        >
          {node.label}
        </span>
      </div>
    );
  };
  const addNode = (parentKey, label, nodeData, type, icon, interrupt) => {
    if (parentKey == null) {
      setData([
        {
          key: "0",
          label: label,
          icon: icon,
          type: type,
          parentKey: parentKey,
          interrupt: interrupt,
          nodeData: nodeData,
          children: [],
          tooltip: "Disclaimer for Node 1",
          typeName: type,
          x: <AudioPlayer record={nodeData} type="prompt" />,
        },
      ]);
      return;
    }
    const newData = [...data];
    const parentNode = findNode(newData, parentKey);

    if (parentNode) {
      const newNode = {
        key: `${parentKey}_${parentNode.children.length + 1}`,
        label,
        nodeData,
        type,
        children: [],
        icon,
        parentKey,
        typeName: type,
      };
      parentNode.children.push(newNode);
      setData(newData);

      return newNode.key;
    }
  };

  const findNode = (tree, key) => {
    for (let node of tree) {
   
      if (node.key === key) {
        return node;
      }
      if (node.children) {
        const foundNode = findNode(node.children, key);
        if (foundNode) {
          return foundNode;
        }
      }
    }
    return null;
  };

  function assignIndexAndCellIdToNodes(nodes, startIndex, startCellId) {
    let currentIndex = startIndex;
    let currentCellId = startCellId;

    for (const node of nodes) {
      let parentNode = findNode(data,node.parentKey)
      node.index = currentIndex++;
      node["cell-id"] = currentCellId++;
      if (node.typeName == "play" || node.typeName == "playChoice") {
        if (node.typeName == "playChoice") {
          node.interrupt = node.nodeData.isChecked;
        }
        node["stop-on-dtmf"] = node.interrupt ? "1" : "0";

        node["list-size"] = "1";
        node["file"] =
          node.typeName == "play"
            ? node.nodeData.fileId + ".wav"
            : node.nodeData.voiceMsg.fileId + ".wav";
        node["type"] = "1";
      }
      if (node.typeName == "choice") {
        if (node.children.length == 0) {
          throw new Error(
            i18next.t('Invalid call flow, Please add choices to "') +
              node.label +
              '"'
          );
        }
        node["type"] = "3";
        node["retry"] = 1;
        node["next-if-false"] = 2;
        node["next-if-invalid"] = parentNode.index;
        node["next-if-timeout"] = parentNode.index;
        node["timeout"] = 10;
        node["mode"] = 1;
        node["map-size"] = node.children.length;
        // node.map = [];
        // console.log(JSON.stringify(node.children));
        // node.children.forEach((element) => {
        //   node.map.push(`${element.nodeData.charInput},${element.index}`);
        // });
      }
      if (node.typeName == "group") {
        node.type = "8";
        node["group-name"] = node.nodeData.agentGrp.groupId;
        if (node.nodeData.waitingMsg != null) {
          node["file"] = node.nodeData.waitingMsg.fileId + ".wav";
        }
      }
      if (node.children && node.children.length > 0) {
        const { updatedIndex, updatedCellId, updatedTree } =
          assignIndexAndCellIdToNodes(
            node.children,
            currentIndex,
            currentCellId
          );

        currentIndex = updatedIndex;
        currentCellId = updatedCellId;
        node.children = updatedTree;
      }
    }
    return {
      updatedIndex: currentIndex,
      updatedCellId: currentCellId,
      updatedTree: nodes,
    };
  }

  function assignMapInChoiceNode(nodes) {
    for (const node of nodes) {
      if (node.type == "3") {
        node.map = [];
        node.children.forEach((element) => {
          node.map.push(`${element.nodeData.charInput},${element.index}`);
        });
      }
      if (node.type == "1") {
        node["next-goto"] = node.children.length ? node.children[0].index : 2;
      }
      if (node.children && node.children.length > 0) {
        assignMapInChoiceNode(node.children);
      }
    }
    setData(nodes);
    return nodes;
  }

  const confirm = (position) => {
    confirmDialog({
      message: i18next.t("You may lose your changes"),
      header: i18next.t("Leave without saving?"),
      icon: "pi pi-info-circle",
      position,
      acceptClassName: "p-button-danger",

      accept: () => {
        props.back(true);
      },
      reject,
      acceptLabel: i18next.t("Yes"),
      rejectLabel: i18next.t("No"),

    });
  };
  const confirm2 = (position) => {

    confirmDialog({
      message: i18next.t("You may lose your changes"),
      header: i18next.t("Leave without saving?"),
      icon: "pi pi-info-circle",
      position,
      acceptClassName: "p-button-danger",

      accept: () => {
        props.navigate();
      },
      reject: () => {
        props.rejectNavigate();
      },
      acceptLabel: i18next.t("Yes"),
      rejectLabel: i18next.t("No"),

    });
  };
  return (
    <>
      <Translation>
        {(t) => (
          <Page
            title={props.editFlag ? t(`Edit Call Flow`) : t(`Create Call Flow`)}
            callFlowBack={true}
            back={() => {
              if(trigger){
                confirm("top");

              }else{
                props.back();
              }
              //    props.back();
            }}
            hasBackArrow={true}
          >
            <PrimeReactProvider>
              <ConfirmPopup />
              <ConfirmDialog />

              <div className="card">
                <Toolbar start={startContent} end={endContent} />
              </div>
              <Toast ref={toast} />
              {modalAddPlay}
              {modalAddChoices}
              {modalCallFlowName}
              {modalEditPlayNode}
              {modalEditChoiceNode}
              {modalEditKeypadchoices}
              <Card>
                <ContextMenu
                  model={menu()}
                  ref={cm}
                  pt={{
                    root: ({ props, state, context }) => ({
                      className: "contextMenuStyle",
                    }),
                  }}
                />{" "}
                {data.length && mount ? (
                  <>
                    <div className="card flex justify-content-center">
                      <Tree
                        value={treeNodes(data)}
                        expandedKeys={expandedKeys}
                        contextMenuSelectionKey={selectedNodeKey}
                        onContextMenuSelectionChange={(e) => {
                          setSelectedNodeKey(e.value);
                        }}
                        onContextMenu={(e) => {
                          cm.current.show(e.originalEvent);
                          document.documentElement.style.setProperty(
                            "--top-value",
                            e.originalEvent.pageY + 1 + "px"
                          );
                          if (props.currLang == "ar") {
                            document.documentElement.style.setProperty(
                              "--right-value",
                              e.originalEvent.pageX - 200 + "px"
                            );
                            document.documentElement.style.setProperty(
                              "--left-value",
                              "auto"
                            );
                          } else {
                            document.documentElement.style.setProperty(
                              "--left-value",
                              e.originalEvent.pageX + 1 + "px"
                            );
                            document.documentElement.style.setProperty(
                              "--right-value",
                              "auto"
                            );
                          }
                        }}
                        className="w-full"
                        nodeTemplate={nodeTemplate}
                      />
                    </div>
                    <Tooltip
                      target=".p-overlay-badge"
                      mouseTrack
                      // mouseTrackLeft={2}
                      mouseTrackTop={2}
                      position={props.currLang == "ar" ? "left" : "right"}
                    >
                      {tooltipText && (
                        <div className="node-tooltip">{tooltipText}</div>
                      )}
                    </Tooltip>

                    <div className="card" style={{ backgroundColor: "white" }}>
                      <Button
                        className="button-submit submit-tree"
                        type="primary"
                        onClick={async () => {
                          if (callFlowName.trim() == "") {
                            setFlowNameInvalid(true);
                            return;
                          }
                          setLoading(true);
                          try {
                            const { updatedIndex, updatedCellId, updatedTree } =
                              assignIndexAndCellIdToNodes(data, 3, 4);
                            assignMapInChoiceNode(updatedTree);

                            await covertJson2XmlAndUploadCallFlow(
                              null,
                              callFlowName,
                              props.sessionId,
                              data,
                              props.editFlag,
                              props.fileId
                            );
                          } catch (e) {
                            // toast.current.show({
                            //   severity: "error",
                            //   summary: i18next.t("Error"),
                            //   detail: i18next.t(e.message),
                            // });
                            showErrorToast(e.message);
                            setLoading(false);

                            return;
                          }
                          props.back(true);
                        }}
                        size={"small"}
                        // disabled={callFlowName.trim() == ""}
                        loading={loading}
                      >
                        {i18next.t("Submit")}
                      </Button>
                      <Button
                        className="button-submit submit-tree"
                        type="primary"
                        onClick={() => {
                          if(trigger){
                            confirm("top");

                          }else{
                            
                           props.back() 
                          }
                          // props.back();
                        }}
                        size={"small"}
                      >
                        {i18next.t("Cancel")}
                      </Button>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </Card>
            </PrimeReactProvider>
          </Page>
        )}
      </Translation>
    </>
  );
}
